/** Read backend `tourCompleted` from login, refresh, or `GET users/profile` payloads. */
export function readTourCompletedFromAuthPayload(payload: unknown): boolean | undefined {
    if (typeof payload === 'boolean') {
        return payload;
    }

    if (!payload || typeof payload !== 'object') {
        return undefined;
    }

    const root = payload as Record<string, unknown>;
    const fromRoot = readTourCompletedField(root);
    if (typeof fromRoot === 'boolean') {
        return fromRoot;
    }

    const data = root['data'];
    if (!data || typeof data !== 'object') {
        return undefined;
    }

    const dataRecord = data as Record<string, unknown>;
    const fromData = readTourCompletedField(dataRecord);
    if (typeof fromData === 'boolean') {
        return fromData;
    }

    const user = dataRecord['user'];
    if (!user || typeof user !== 'object') {
        return undefined;
    }

    return readTourCompletedField(user as Record<string, unknown>);
}

function readTourCompletedField(record: Record<string, unknown>): boolean | undefined {
    if (typeof record['tourCompleted'] === 'boolean') {
        return record['tourCompleted'];
    }

    if (typeof record['tour_completed'] === 'boolean') {
        return record['tour_completed'];
    }

    return undefined;
}
